"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeSchema = exports.EstablishmentSchema = exports.CorporateWebsiteSchema = exports.CompanyNameSchema = exports.CompanyLogoUrlSchema = exports.CeoSchema = exports.CapitalSchema = exports.BusinessDescriptionSchema = exports.COMPANY_PROFILE_MAX_LENGTH = void 0;
const zod_1 = require("zod");
exports.COMPANY_PROFILE_MAX_LENGTH = {
    BUSINESS_DESCRIPTION: 300,
    CAPITAL: 30,
    CEO: 30,
    COMPANY_LOGO_URL: 300,
    COMPANY_NAME: 200,
    CORPORATE_WEBSITE: 200,
    ESTABLISHMENT: 30,
    OFFICE: 300,
};
exports.BusinessDescriptionSchema = zod_1.z
    .string()
    .max(exports.COMPANY_PROFILE_MAX_LENGTH.BUSINESS_DESCRIPTION, {
    message: `Must be ${exports.COMPANY_PROFILE_MAX_LENGTH.BUSINESS_DESCRIPTION} characters or fewer.`,
});
exports.CapitalSchema = zod_1.z.number();
exports.CeoSchema = zod_1.z
    .string()
    .max(exports.COMPANY_PROFILE_MAX_LENGTH.CEO, {
    message: `Must be ${exports.COMPANY_PROFILE_MAX_LENGTH.CEO} characters or fewer.`,
});
exports.CompanyLogoUrlSchema = zod_1.z
    .string()
    .url({ message: 'Must be a valid URL.' })
    .max(exports.COMPANY_PROFILE_MAX_LENGTH.COMPANY_LOGO_URL, {
    message: `Must be ${exports.COMPANY_PROFILE_MAX_LENGTH.COMPANY_LOGO_URL} characters or fewer.`,
});
exports.CompanyNameSchema = zod_1.z
    .string()
    .min(1, { message: 'Company name is required.' })
    .max(exports.COMPANY_PROFILE_MAX_LENGTH.COMPANY_NAME, {
    message: `Must be ${exports.COMPANY_PROFILE_MAX_LENGTH.COMPANY_NAME} characters or fewer.`,
});
exports.CorporateWebsiteSchema = zod_1.z
    .string()
    .url({ message: 'Must be a valid URL.' })
    .max(exports.COMPANY_PROFILE_MAX_LENGTH.CORPORATE_WEBSITE, {
    message: `Must be ${exports.COMPANY_PROFILE_MAX_LENGTH.CORPORATE_WEBSITE} characters or fewer.`,
});
exports.EstablishmentSchema = zod_1.z
    .string()
    .max(exports.COMPANY_PROFILE_MAX_LENGTH.ESTABLISHMENT, {
    message: `Must be ${exports.COMPANY_PROFILE_MAX_LENGTH.ESTABLISHMENT} characters or fewer.`,
});
exports.OfficeSchema = zod_1.z
    .string()
    .max(exports.COMPANY_PROFILE_MAX_LENGTH.OFFICE, {
    message: `Must be ${exports.COMPANY_PROFILE_MAX_LENGTH.OFFICE} characters or fewer.`,
});
